export const BONUS_NIGHT_THRESHOLD = 5;
